import {
  actionCardCommands as commands,
  actionCardFailureMessage,
  type ActionCardCommandOutcome,
} from '@littlebird/action-cards';
import { toast } from 'sonner';

export const surfaceOutcome = (
  outcome: ActionCardCommandOutcome
): ActionCardCommandOutcome => {
  const message = actionCardFailureMessage(outcome);
  if (message) toast.error(message);
  return outcome;
};

const surfacing = async (
  run: Promise<ActionCardCommandOutcome>
): Promise<ActionCardCommandOutcome> => surfaceOutcome(await run);

// The package computes and mutates; presenting failures is this app's job.
export const actionCardCommands = {
  acknowledge: (...args: Parameters<typeof commands.acknowledge>) =>
    surfacing(commands.acknowledge(...args)),
  completeExternally: (
    ...args: Parameters<typeof commands.completeExternally>
  ) => surfacing(commands.completeExternally(...args)),
  dismiss: (...args: Parameters<typeof commands.dismiss>) =>
    surfacing(commands.dismiss(...args)),
  keepWatched: (...args: Parameters<typeof commands.keepWatched>) =>
    surfacing(commands.keepWatched(...args)),
  moveWatchedToWorking: (
    ...args: Parameters<typeof commands.moveWatchedToWorking>
  ) => surfacing(commands.moveWatchedToWorking(...args)),
  notWorkingOnWatched: (
    ...args: Parameters<typeof commands.notWorkingOnWatched>
  ) => surfacing(commands.notWorkingOnWatched(...args)),
  saveDraft: (...args: Parameters<typeof commands.saveDraft>) =>
    surfacing(commands.saveDraft(...args)),
  restoreGroup: async (...args: Parameters<typeof commands.restoreGroup>) =>
    (await commands.restoreGroup(...args)).map(surfaceOutcome),
} as const;
